import { type ReactNode } from 'react'
import {
  AutoSkeleton,
  type SkeletonColor,
  useIsSkeleton,
} from '@/components/Skeleton'
import styles from './SectionHeadline.module.css'

interface SectionHeadlineProps {
  children?: ReactNode
  id?: string
  isSkeleton?: boolean
  skeletonColor?: SkeletonColor

  /**
   * An optional element to place on the right side of the title, usually
   * a button.
   */
  action?: ReactNode
  /**
   * Test ID attribute.
   */
  testId?: string
}

/**
 * Section Headline
 */
export function SectionHeadline({
  id,
  children,
  action,
  isSkeleton,
  skeletonColor,
  testId,
}: SectionHeadlineProps) {
  isSkeleton = useIsSkeleton(isSkeleton)
  return (
    <div className={styles.root} data-test={testId}>
      <h2 id={id} className={styles.text}>
        <AutoSkeleton
          topCorrection="-0.05em"
          isSkeleton={isSkeleton}
          color={skeletonColor}
        >
          {children}
        </AutoSkeleton>
      </h2>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  )
}
